import React, {useContext} from "react";
import {APP_NAME} from "../../constants";
import logo from '../../assets/logo.png'
import plates from '../../assets/plates.png'
import menus from '../../assets/menus.png'
import clients from '../../assets/clients.png'
import clientResults from '../../assets/client_results.png'
import notifications from '../../assets/notifications.png'
import rating from '../../assets/rating.png'
import {Container, Card} from "react-bootstrap";
import {NavLink} from "react-router-dom";
import CurrentUser from "../../helpers/Api";

const Home = () => {

  const features = [{
    img: plates, title: 'Management Retete', description: 'Adaugati si modificati retetele foarte usor'
  }, {
    img: menus, title: 'Management Meniuri', description: 'Grupati retetele existente in meniuri'
  }, {
    img: clients,
    title: 'Management clienti',
    description: 'Invitati clientii dumneavoastra sa isi creeze cont si shareuiti cu ei meniurile'
  }, {
    img: clientResults,
    title: 'Vizualizare rezultate clienti',
    description: 'Vedeti graficul cu rezultatele masuratorilor'
  }, {
    img: notifications,
    title: 'Notificari',
    description: 'Primiți notificari in aplicatie legat de actiunile clientiilor'
  }, {
    img: rating,
    title: 'Feedback',
    description: 'Puteți primi feedback si rating in legatura cu retetele dumneavoastra.'
  },]

  const FeaturesList = ({ list, width = '350px' }) => {

    return (<>
      {list.map(({ img, title, description }, i) => (
        <Card style={{ width: width }} key={i + Math.random()}
              className="d-flex align-items-center p-4 py-2 align-content-between rounded-5">
          <Card.Img variant="top" src={img} style={{ width: "300px" }} className="m-3" />
          <Card.Body>
            <Card.Title className="mb-2 fw-bold">{title}</Card.Title>
            <Card.Text>{description}</Card.Text>
          </Card.Body>
        </Card>))}
    </>)
  }

  return (
    <div className="">
      <Container
        className="d-flex flex-column justify-content-center align-items-center text-center px-3 py-5"
      >
        <div className="d-flex align-items-center mt-5">
          <h1 className="display-5 fw-bold mb-3 pt-3">Bine ati venit la </h1>
          <img src={logo} alt='logo' className="logo-home me-5 ms-3" />
        </div>
        <h3 className="my-5">
          Locul unde furnizorii de meniuri pot gestiona și împărtăși meniurile
          <br />
          cu clienții lor într-un mod simplu și eficient
        </h3>
        {!CurrentUser() &&
          <div className="mb-5">
            <NavLink to="/inregistrare" className="btn btn-primary close-nav fs-5">Inregistrați-vă</NavLink>
          </div>
        }
      </Container>

      <div className="bg-body-branding py-3 pb-5">
        <Container className="mt-5 text-center d-flex justify-content-center flex-wrap gap-4">
          <FeaturesList list={features} />
        </Container>
      </div>

    </div>)
};

export default Home;
